export default __webpack_public_path__ + "static/game-intro-chars-5117d987b13100d10ad7e90936c257c2.png";